import type { SVGProps } from 'react';

interface CheckIconProps extends SVGProps<SVGSVGElement> {
  variant?: 'thin';
}

export const CheckIcon = ({ variant, ...props }: CheckIconProps) => {
  if (variant === 'thin') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        {...props}
      >
        <path
          d="M9.80177 3.12394C9.96149 2.9587 10.2206 2.95867 10.3803 3.12394C10.54 3.28942 10.5399 3.55834 10.3803 3.7239L4.92562 9.37575L4.89472 9.405C4.88409 9.41398 4.87295 9.42212 4.86169 9.42984C4.8163 9.46093 4.7663 9.48184 4.71467 9.4922C4.5986 9.51554 4.47447 9.48648 4.37802 9.405L4.34712 9.37575L1.6198 6.54982C1.46005 6.3843 1.46008 6.11596 1.6198 5.95042C1.77956 5.78488 2.03853 5.78488 2.19829 5.95042L4.63584 8.47609L9.80177 3.12394Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M19.6035 6.24788C19.923 5.9174 20.4411 5.91735 20.7605 6.24788C21.0799 6.57884 21.0797 7.11668 20.7605 7.44779L9.85123 18.7515L9.78944 18.81C9.76817 18.828 9.7459 18.8442 9.72339 18.8597C9.63259 18.9219 9.53259 18.9637 9.42935 18.9844C9.19721 19.0311 8.94894 18.973 8.75604 18.81L8.69425 18.7515L3.2396 13.0996C2.9201 12.7686 2.92016 12.2319 3.2396 11.9008C3.55913 11.5698 4.07706 11.5698 4.39658 11.9008L9.27167 16.9522L19.6035 6.24788Z" />
    </svg>
  );
};
